import { formatCurrency } from '@if/core/utils'
import { Card, CardContent, Skeleton, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface CalculatorPaymentDisplayProps {
  isComputing: boolean
  monthlyEquivalent: number | null
  showProtectionPlanNote: boolean
  isEstimate?: boolean
}

const CalculatorPaymentDisplay = ({
  isComputing,
  monthlyEquivalent,
  showProtectionPlanNote,
  isEstimate = false,
}: CalculatorPaymentDisplayProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Card
      sx={{
        color: 'primary.contrastText',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      }}
    >
      <CardContent sx={{ textAlign: 'center' }}>
        <Typography variant="overline">{t('calculator.estimatedMonthlyPayment')}</Typography>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            minHeight: 72,
          }}
        >
          {isEstimate && <Typography variant="subtitle1">{t('calculator.asLowAs')}</Typography>}
          {isComputing ? (
            <Skeleton variant="rounded" width={180} height={52} />
          ) : (
            <>
              <Typography variant="h3" fontWeight={800}>
                {monthlyEquivalent !== null ? formatCurrency(monthlyEquivalent) : '—'}
              </Typography>
            </>
          )}
        </Stack>
        <Typography variant="caption" sx={showProtectionPlanNote ? null : { visibility: 'hidden' }}>
          {t('calculator.includingProtectionPlan')}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default CalculatorPaymentDisplay
